import { PropsWithChildren, useMemo } from 'react';
import { IRestClient, RestClientContext } from './RestClientContext';
import { MockRestClient } from './mockRestClient';
import { RestClient } from './restClient';

type Props = {
    baseUrl: string;
    initData: string;
};

export const RestClientProvider = ({
    baseUrl,
    initData,
    children,
}: PropsWithChildren<Props>) => {
    const client = useMemo<IRestClient>(() => {
        const useMock = process.env.REACT_APP_USE_MOCK_CLIENT === 'true';
        if (useMock) return new MockRestClient(baseUrl, initData);
        return new RestClient(baseUrl, initData);
    }, [baseUrl, initData]);

    return (
        <RestClientContext.Provider value={client}>
            {children}
        </RestClientContext.Provider>
    );
};